import type { ReactNode } from "react";
import { Link } from "react-router";

// Mirrors Button's variants so a navigating action reads identically to an
// acting one at the call site.
type Variant = "primary" | "secondary" | "ghost" | "danger";

/**
 * A link that looks like a button.
 *
 * WHY THIS EXISTS: `<Link><Button/></Link>` renders `<a><button/></a>`. That is
 * invalid HTML and gives one action two interactive elements — two tab stops,
 * and activation that differs between Enter and Space depending on which one
 * the focus landed on. Navigation is an anchor's job, so the anchor carries the
 * button's styling rather than wrapping a real button.
 *
 * Use `Button` when the action does something; use this when it goes somewhere.
 */
export function ButtonLink({
  to,
  variant = "primary",
  children,
  className,
}: {
  to: string;
  variant?: Variant;
  children: ReactNode;
  className?: string;
}) {
  return (
    <Link className={`btn btn--${variant}${className ? ` ${className}` : ""}`} to={to}>
      {children}
    </Link>
  );
}
